/** m d mloader constant  */
declare const MDMloader;
/** particles j s constant  */
declare const particlesJS;
/** PARTICLES_WRAPPER_ID constant  */
const PARTICLES_WRAPPER_ID = 'particles-js';

/** INITIAL_LOADER_STATES constant  */
export const INITIAL_LOADER_STATES = {
	LOADING_CONFIGS: 'Loading Configs',
};

/**
 * 'InitialLoaderHelper' class definition.
 */
export class InitialLoaderHelper {
	/**
	 * Show.
	 * @returns {void}
	 */
	public static show() {
		// At this point we assume that the html tag has only 1 class
		/** theme class constant  */
		const themeClass = document.querySelector('html').classList.toString();

		MDMloader.loaderEl = document.querySelector('.initial-loader');
		MDMloader.projectLabelEl = MDMloader.loaderEl.querySelector('.label');
		MDMloader.statusLabelEl = MDMloader.loaderEl.querySelector('.status');

		particlesJS.load(PARTICLES_WRAPPER_ID, `assets/json/particlesjs-config-${themeClass}.json`, () => {
			MDMloader.loaderEl.classList.remove('hidden');
		});
	}

	/**
	 * Set text.
	 * @param {string} text
	 * @returns {void}
	 */
	public static setText(text: string = '') {
		MDMloader.statusLabelEl.textContent = text;
	}

	/**
	 * Set progress.
	 * @param {string} text
	 * @returns {void}
	 */
	public static setProgress(text: string = '') {
		MDMloader.progressLabelEl.textContent = text;
	}

	/**
	 * Remove.
	 * @returns {void}
	 */
	public static remove() {
		MDMloader.loaderEl.remove();
		/** PARTICLE_JS_DOM constant  */
		const PARTICLE_JS_DOM = 'pJSDom';

		// destroy of all instances from particlesJs
		window[PARTICLE_JS_DOM][0]?.pJS?.fn?.vendors?.destroypJS();
		window[PARTICLE_JS_DOM] = [];
	}
}
